






























































































































































































import { Component } from 'vue-property-decorator'
import {Getter} from "vuex-class";
import {Tabs} from "wings-ui-components";
import {SmsGroupFilter} from '@/components/SMS';
import GroupCharts from "@/components/Statistics/GroupCharts.vue";
import BaseItemsPage from '@/pages/Pages/BaseItemsPage';
import {SmsGroupItem} from '@/store/sms/statistic/types';
import {dateFilter} from "@/utils/date-util";

@Component({
  components: {Tabs,SmsGroupFilter,GroupCharts},
  filters: {dateFilter}
})
export default class SmsGroup extends BaseItemsPage<SmsGroupItem> {

  @Getter("smsStatisticGroup") responseItems!: SmsGroupItem[];

  is_show_graphics = true;
  is_show_filter = true;
  is_show_filter_additional = false;

  currentSort= "message_category";
  currentSortOrder= "desc";

  tableFields = this.tableFieldsDefault;

  group_by = '';
  optionally_group_by = '';

  get tableFieldsDefault() {
    let priceFields = ['partner_price', 'provider_price'];
    return [
      ...['transmitted', 'delivered', 'not_delivered', 'expired', 'failed', 'rejected', 'deferred', 'total'],
      ...(this.isShowFinanceInfo ? priceFields : []),
    ]
  }

  getFieldName(name: string) {
    if (name == 'partner_price') return 'income'
    if (name == 'provider_price') return 'rate'
    return name
  }

  onGroupByChange(data: any) {
    this.group_by = data.groupBy
    this.optionally_group_by = data.optionallyGroupBy
  }

  print(item: string, totalRow: boolean) {
    if (totalRow) return this.group_by ? '' : this.$t('inAll');
    return item ?? this.$t('unnamed')
  }

  getData(): SmsGroupItem[] {
    return this.responseItems;
  }

  get isShowFinanceInfo(): boolean {
    let value: string = localStorage.getItem("show-finance-info") || "true";
    return JSON.parse(value)
  }

  get totalData():SmsGroupItem {
    let total = {
      totalRow: 'totalRow',
      transmitted: 0,
      transmitted_parts: 0,
      delivered: 0,
      delivered_parts: 0,
      not_delivered: 0,
      not_delivered_parts: 0,
      expired: 0,
      expired_parts: 0,
      failed: 0,
      failed_parts: 0,
      rejected: 0,
      rejected_parts: 0,
      deferred: 0,
      deferred_parts: 0,
      total: 0,
      total_parts: 0,
      partner_price: '0',
      provider_price: '0',
    };
    this.tableData.forEach((row) => {
      total.transmitted += row.transmitted;
      total.transmitted_parts += row.transmitted_parts;
      total.delivered += row.delivered;
      total.delivered_parts += row.delivered_parts;
      total.not_delivered += row.not_delivered;
      total.not_delivered_parts += row.not_delivered_parts;
      total.expired += row.expired;
      total.expired_parts += row.expired_parts;
      total.failed += row.failed;
      total.failed_parts += row.failed_parts;
      total.rejected += row.rejected;
      total.rejected_parts += row.rejected_parts;
      total.deferred += row.deferred;
      total.deferred_parts += row.deferred_parts;
      total.total += row.total;
      total.total_parts += row.total_parts;
      total.partner_price = String((Number(row.partner_price) + Number(total.partner_price)).toFixed(4));
      total.provider_price = String((Number(row.provider_price) + Number(total.provider_price)).toFixed(4));
    });
    return total;
  }

  get campareData():any[] {
    return [...this.queriedData, this.totalData]
  }
}
